/** Destination for landing-page school enquiries (delivered server-side, no mailto). */
export const LANDING_ENQUIRY_EMAIL = 'vishalvikash93@gmail.com';
export const LANDING_ENQUIRY_SUBJECT = 'School enquiry — SkoolFix';

export type LandingEnquiryPayload = {
  name: string;
  email: string;
  phone: string;
  schoolName?: string;
  city?: string;
  studentCount?: string;
  message?: string;
};

type FormSubmitResponse = {
  success?: string | boolean;
  message?: string;
};

/**
 * Submit a landing enquiry without opening the user's email app.
 * Uses FormSubmit AJAX by default; override with REACT_APP_LANDING_ENQUIRY_URL when a backend route exists.
 */
export async function submitLandingEnquiry(payload: LandingEnquiryPayload): Promise<void> {
  const endpoint =
    (process.env.REACT_APP_LANDING_ENQUIRY_URL || '').trim() ||
    `https://formsubmit.co/ajax/${encodeURIComponent(LANDING_ENQUIRY_EMAIL)}`;

  const res = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      name: payload.name,
      email: payload.email,
      phone: payload.phone,
      school_name: payload.schoolName || '',
      city: payload.city || '',
      student_count: payload.studentCount || '',
      message: payload.message || '',
      _subject: LANDING_ENQUIRY_SUBJECT,
      _template: 'table',
      _captcha: 'false',
    }),
  });

  let data: FormSubmitResponse | null = null;
  try {
    data = (await res.json()) as FormSubmitResponse;
  } catch {
    data = null;
  }

  if (!res.ok) {
    throw new Error(data?.message || 'Could not send enquiry. Please try again.');
  }

  const ok = data?.success === true || data?.success === 'true' || res.status === 200;
  if (!ok) {
    throw new Error(data?.message || 'Could not send enquiry. Please try again.');
  }
}
